if (!customElements.get('family-bundle-groups')) {
  class FamilyBundleGroups extends HTMLElement {
    connectedCallback() {
      this.onPillClick = this.onPillClick.bind(this);
      this.addEventListener('click', this.onPillClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onPillClick);
    }

    /**
     * Scrolls to the group a pill points at, then moves focus there so keyboard users continue from it.
     * @param {MouseEvent} event
     */
    onPillClick(event) {
      const pill = event.target.closest('.family-bundle-groups__pill');
      if (!pill) return;

      const group = document.getElementById(pill.dataset.target);
      if (!group) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      group.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      group.focus({ preventScroll: true });
    }
  }

  customElements.define('family-bundle-groups', FamilyBundleGroups);
}
